import { render, staticRenderFns } from "./OverviewSessionDetail.vue?vue&type=template&id=3f40e64a&scoped=true"
import script from "./OverviewSessionDetail.vue?vue&type=script&lang=js"
export * from "./OverviewSessionDetail.vue?vue&type=script&lang=js"
import style0 from "./OverviewSessionDetail.vue?vue&type=style&index=0&id=3f40e64a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f40e64a",
  null
  
)

export default component.exports